require('./join-zoom-meeting-modal.style.less');
require('./join-zoom-meeting-modal-template.html');

/*jshint esnext: true */

angular.module('bbl.directives.join-zoom')
  .directive('joinZoomMeetingModal', [function joinZoomMeetingModalDirective() {
    return {
      restrict: 'EA',
      templateUrl: 'join-zoom-meeting-modal-template.html',
      scope: {
        bridge: '=',
        isVisible: '=',
      },
      controller: ['$scope', 'Api', 'Toast', 'PusherPubsub', joinZoomMeetingModalCtrl],
      link: function($scope, $el) {
        var modalEl = $el.find('.modal');
        modalEl.modal('show');

        modalEl.on('hidden.bs.modal', function() {
          $scope.isVisible = false;
          setTimeout($scope.$apply.bind($scope));
        });

        $scope.toggle = function(toggle) {
          modalEl.modal(toggle);
        };
      }
    };
  }]);

function joinZoomMeetingModalCtrl($scope, Api, Toast, PusherPubsub) {
  $scope.loading = false;

  $scope.meeting = {
    id: null,
    dialIn: null,
    passcode: null,
    invite: null,
  };

  $scope.phoneNumberPattern = (function() {
    var regexp = /^[(]{0,1}[0-9]{3,10}[)\.\- ]{0,1}[0-9]{3,10}[\.\- ]{0,1}[0-9]{4,10}$/;
    return {
      test: function(value) {
        return regexp.test(value);
      }
    };
  })();

  $scope.parseInvite = function() {
    var regexpDialIn = /\+([0-9]*),,/gm;
    var mDialIn = $scope.meeting.invite.matchAll(regexpDialIn);
    if (mDialIn !== null){
      var mm = Array.from(mDialIn);
      for(var v in mm) {
        if (mm[v].length == 2) {
          $scope.meeting.dialIn = mm[v][1].replaceAll(' ', '');

          break;
        }
      }
    }

    var regexPassCode = /Passcode:[ ]?([0-9]*)/gmi;
    var mPassCode = $scope.meeting.invite.matchAll(regexPassCode);
    if (mPassCode !== null){
      var mp = Array.from(mPassCode);
      for(var vp in mp) {
        if (mp[vp].length == 2) {
          if (mp[vp][1].length > 0) {
            $scope.meeting.passcode = mp[vp][1].replaceAll(' ', '');
            break;
          }
        }
      }
    }

    var regexMeetingId = /Meeting ID:([0-9 ]*)/gm;
    var mMeetingId = $scope.meeting.invite.matchAll(regexMeetingId);
    if (mMeetingId !== null){
      var mi = Array.from(mMeetingId);
      for(var vd in mi) {
        if (mi[vd].length == 2) {
          $scope.meeting.id = mi[vd][1].replaceAll(' ', '');
          break;
        }
      }
    }
  };

  var waitForJoinedEvent = function(bridge) {
    return new Promise(function(resolve, reject) {
      var subj = PusherPubsub.sub(PusherPubsub.types.CALLER_JOINED, function(data) {
        var call = data.conferenceCall || {};
        if (data.bridgeId+'' !== bridge || call.direction !== 'out') {
          return;
        }

        unsub();
        resolve();
      });

      var unsub = subj && subj.unsub && typeof subj.unsub === 'function' ? subj.unsub : angular.noop;
      $scope.$on('$destroy', unsub);
    });
  };

  $scope.join = function() {
    var bridge = $scope.bridge;
    var meetingId = $scope.meeting.id.toString().replace(/\D+/g, '');
    var passcode = $scope.meeting.passcode.toString().replace(/\D+/g, '');
    var tel = $scope.meeting.dialIn.replace(/[^0-9]+/g, "");

    $scope.loading = true;
    Api.bridges.joinZoomMeeting(bridge+'/'+tel+',,'+meetingId+'%23'+passcode)
      .then(function() {
        return waitForJoinedEvent(bridge)
          .then(Toast.notify.bind(0, 'Successfully joined Zoom Meeting!'));
      })
      .catch(Toast.error.bind(0, "{{'Something went wrong performing this action'|translate}}. {{'Please try again!'|translate}}"))
      .then($scope.toggle.bind($scope, 'hide'))
      .then(function() {
        $scope.loading = false;
      });
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/join-zoom/join-zoom-meeting-modal/index.js
 ** module id = 337
 ** module chunks = 0
 **/